module.exports = __webpack_public_path__ + "assets/img/serve8.a4eae121.png";